// UserAuthContext.js
import Cookies from "js-cookie";
import { createContext, useState, useEffect, useContext } from "react";
import { markLoggingOut } from "./navigationService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = Cookies.get("_auth");
    setIsAuthenticated(!!token); // token exists = authenticated
    setLoading(false); // done checking
  }, []);

  const login = () => setIsAuthenticated(true);
  const logout = () => {
    markLoggingOut();
    Cookies.remove("_auth");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
